// src/pages/TherapistServicesPage.js
import React, { useEffect, useState } from 'react'
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
} from 'firebase/firestore'
import { db } from '../firebaseConfig'

export default function TherapistServicesPage() {
  const [services, setServices] = useState([])
  const [newService, setNewService] = useState('')
  const [editId, setEditId] = useState(null)
  const [editValue, setEditValue] = useState('')
  const [loading, setLoading] = useState(false)

  // 🔹 Ambil data layanan dari Firestore
  const fetchServices = async () => {
    setLoading(true)
    const snap = await getDocs(collection(db, 'therapists_services'))
    const data = snap.docs.map((doc) => ({
      id: doc.id,
      name: doc.data().name,
    }))
    setServices(data)
    setLoading(false)
  }

  useEffect(() => {
    fetchServices()
  }, [])

  // ➕ Tambah layanan baru
  const handleAdd = async (e) => {
    e.preventDefault()
    if (!newService.trim()) return alert('Masukkan nama layanan!')
    await addDoc(collection(db, 'therapists_services'), {
      name: newService.trim(),
    })
    setNewService('')
    fetchServices()
    alert('✅ Layanan berhasil ditambahkan')
  }

  // ✏️ Edit layanan
  const handleEdit = async (id) => {
    if (!editValue.trim()) return alert('Nama layanan tidak boleh kosong!')
    await updateDoc(doc(db, 'therapists_services', id), {
      name: editValue.trim(),
    })
    setEditId(null)
    setEditValue('')
    fetchServices()
    alert('✅ Layanan diperbarui')
  }

  // 🗑️ Hapus layanan
  const handleDelete = async (id) => {
    if (!window.confirm('Yakin ingin menghapus layanan ini?')) return
    await deleteDoc(doc(db, 'therapists_services', id))
    fetchServices()
    alert('🗑️ Layanan dihapus')
  }

  return (
    <div className="min-h-screen bg-gray-950 text-gray-200 p-6">
      <h2 className="text-2xl font-bold mb-6">
        💆‍♀️ Manajemen Layanan Therapist
      </h2>

      {/* FORM TAMBAH */}
      <form
        onSubmit={handleAdd}
        className="bg-gray-900 p-4 rounded-lg border border-gray-800 mb-6 flex items-center gap-3"
      >
        <input
          type="text"
          value={newService}
          onChange={(e) => setNewService(e.target.value)}
          placeholder="Nama layanan baru..."
          className="flex-1 p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
        />
        <button
          type="submit"
          className="bg-green-600 hover:bg-green-700 px-4 py-2 rounded-lg text-white font-medium"
        >
          Tambah
        </button>
      </form>

      {/* DAFTAR LAYANAN */}
      {loading ? (
        <p className="text-gray-400">Memuat layanan...</p>
      ) : services.length === 0 ? (
        <p className="text-gray-500 italic">
          Belum ada layanan terdaftar di Firestore.
        </p>
      ) : (
        <div className="bg-gray-900 border border-gray-800 rounded-lg shadow-lg overflow-hidden">
          <table className="min-w-full text-sm text-gray-300">
            <thead className="bg-gray-800 text-gray-100">
              <tr>
                <th className="p-3 text-left font-semibold">Nama Layanan</th>
                <th className="p-3 text-center font-semibold">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {services.map((srv) => (
                <tr
                  key={srv.id}
                  className="border-t border-gray-800 hover:bg-gray-800/60 transition"
                >
                  <td className="p-3">
                    {editId === srv.id ? (
                      <input
                        type="text"
                        value={editValue}
                        onChange={(e) => setEditValue(e.target.value)}
                        className="w-full p-2 bg-gray-800 border border-gray-700 rounded-lg text-white"
                      />
                    ) : (
                      srv.name
                    )}
                  </td>
                  <td className="p-3 text-center space-x-2">
                    {editId === srv.id ? (
                      <>
                        <button
                          onClick={() => handleEdit(srv.id)}
                          className="bg-green-600 hover:bg-green-700 text-white px-3 py-1 rounded-lg text-sm"
                        >
                          Simpan
                        </button>
                        <button
                          onClick={() => {
                            setEditId(null)
                            setEditValue('')
                          }}
                          className="bg-gray-700 hover:bg-gray-600 text-white px-3 py-1 rounded-lg text-sm"
                        >
                          Batal
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => {
                            setEditId(srv.id)
                            setEditValue(srv.name)
                          }}
                          className="bg-yellow-600 hover:bg-yellow-700 text-white px-3 py-1 rounded-lg text-sm"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => handleDelete(srv.id)}
                          className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded-lg text-sm"
                        >
                          Hapus
                        </button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
